class AreaStyle

  activeClass: 'is-active'

  constructor: (@elm) ->
    @$elm = $ @elm
    @$button = @$elm.find 'li'
    @$contents = $ '.js-style-body'
    @$style = @$contents.find 'a'
    @$button.on 'click', @changeTab

  changeTab: (event) =>
    elm = event.currentTarget
    $elm = $ elm
    targetArea = $elm.data 'area'
    $ elm
      .addClass @activeClass
      .siblings()
      .removeClass @activeClass

    _.forEach @$style, (elm, i) ->
      $elm = $ elm
      urlSplit = elm.href.split '/'
      changeURL = elm.href.replace urlSplit[4], targetArea
      elm.href = changeURL

      $elm
        .velocity 'stop', false
        .velocity
          scale: 0.8
        ,
          duration: 100
          delay: i * 50
        .velocity
          scale: 1
        ,
          duration: 100

    @$button.removeClass @activeClass
    elm.classList.add @activeClass

export default AreaStyle



// WEBPACK FOOTER //
// ./webpack/imports/view/area-style.coffee